import { useEffect } from 'react'
import Select from 'react-select'
import { FaPlus, FaTrashAlt } from 'react-icons/fa'

import Input from '../../shared/components/form/input'
import selectStyles from '../../shared/css/SelectStyle'

import './Finance.css'

// Rateio entre categorias — compartilhado por FormFinanceEntry e FormFinanceRecurring (mesma
// regra nos dois: soma das linhas precisa bater com o valor total, e enquanto só existe 1
// categoria seu valor segue o total automaticamente).
function AllocationsField({ categoryOptions, totalValue, allocations, setAllocations }) {
    useEffect(() => {
        if (allocations.length === 1) {
            setAllocations([{ ...allocations[0], value: totalValue }])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalValue])

    function updateAllocation(index, field, value) {
        setAllocations(allocations.map((a, i) => i === index ? { ...a, [field]: value } : a))
    }

    function addAllocation() {
        setAllocations([...allocations, { category: null, value: '' }])
    }

    function removeAllocation(index) {
        setAllocations(allocations.filter((_, i) => i !== index))
    }

    const allocationSum = allocations.reduce((acc, a) => acc + (parseFloat(a.value) || 0), 0)
    const totalMismatch = allocations.length > 1 && Math.abs(allocationSum - (parseFloat(totalValue) || 0)) > 0.005

    return (
        <div className="fin-allocations">
            <label className="input-label">Categoria {allocations.length > 1 && '/ Rateio'}:</label>
            {allocations.map((a, i) => (
                <div key={i} className="fin-allocation-row">
                    <div className="form-group">
                        <Select
                            options={categoryOptions}
                            styles={selectStyles}
                            value={a.category}
                            onChange={(opt) => updateAllocation(i, 'category', opt)}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            placeholder="Selecione a categoria..."
                        />
                    </div>
                    {allocations.length > 1 && (
                        <div className="form-group">
                            <Input type="number" name={`allocationValue${i}`} placeholder="0.00" handleOnChange={(e) => updateAllocation(i, 'value', e.target.value)} value={a.value} />
                        </div>
                    )}
                    {allocations.length > 1 && (
                        <FaTrashAlt className="shd-icon-row-trash" title="Remover" onClick={() => removeAllocation(i)} />
                    )}
                </div>
            ))}
            <button type="button" className="fin-add-link" onClick={addAllocation}>
                <FaPlus size={12} /><span>Ratear entre mais categorias</span>
            </button>
            {allocations.length > 1 && (
                <span className={`fin-allocation-total ${totalMismatch ? 'fin-allocation-total-mismatch' : ''}`}>
                    Soma do rateio: R$ {allocationSum.toFixed(2)} {totalMismatch && `(precisa bater com R$ ${(parseFloat(totalValue) || 0).toFixed(2)})`}
                </span>
            )}
        </div>
    )
}

export { AllocationsField }
export function allocationsMismatch(allocations, totalValue) {
    if (allocations.length <= 1) return false
    const sum = allocations.reduce((acc, a) => acc + (parseFloat(a.value) || 0), 0)
    return Math.abs(sum - (parseFloat(totalValue) || 0)) > 0.005
}
export default AllocationsField
